@if (!isHandset) {
  <div class="session-page" (window:resize)="onResize($event)">
    <div class="session-titles">
      <!--
      <div class="session-titles-header">
        <h3>Menu Client</h3>
      </div> -->
      <!-- <button matButton mat-button (click)="showMenu = !showMenu;"><mat-icon>+</mat-icon></button> -->
      <div class="session-titles-content" >
        <app-dealer-menu></app-dealer-menu>
      </div>
    </div>
    <div class="session-content">
      <router-outlet></router-outlet>
      @if ((fetchingResults$ | async)!) {
        <p style="text-align:center">
          <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
        </p>
      }
    </div>
  </div>
}


@if (isHandset) {
  <div class="session-page" (window:resize)="onResize($event)" >
    <mat-drawer-container class="sidenav-container" autosize>
      <mat-drawer #drawer class="sidenav-menu" mode="over" position="end">
        <div class="session-titles-header">
          <h3>Menu Client&nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <app-dealer-menu></app-dealer-menu>
      </mat-drawer>
      <div class="sidenav-page">
        <div class="session-top">
          <h3>Menu Client &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div class="session-content">
          <router-outlet></router-outlet>
          @if ((fetchingResults$ | async)!) {
            <p style="text-align:center">
              <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
            </p>
          }
        </div>
      </div>
    </mat-drawer-container>
  </div>
}